<!-- 市级管理 -->
<template>
  <div class="examlocation">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入市代名称" style="width: 200px; margin-right:10px" @keyup.enter.native="tableLoad" @clear="
            query.query = ''
            tableLoad()
          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.provinceId" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-button type="primary" size="small" style="margin-right:10px" @click="operatInfo(1)" v-if="$roleFilter('city::add')">添加</el-button>
      <FileOperatDropdown @reLoad="tableLoad" :roles="[$roleFilter('city::download'),$roleFilter('city::import'),$roleFilter('city::export')]" :uploadUrl="'examination/site/import'" :downloadUrl="'examination/site/download'" :exportUrl="'/examination/site/export'" :exportData="query" :butText="['下载模板', '导入市代', '导出市代']" />
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" :height="$store.getters.getTableHeight">
      <el-table-column show-overflow-tooltip prop="examSiteName" width="200" label="市代名称" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="provinceName" width="200" label="所属省份" align="center"></el-table-column>
      <!-- <el-table-column label="财务分成比例" width="140" align="center">
        <template slot-scope="{ row }"> {{ row.percent }}% </template>
      </el-table-column> -->
      <!-- <el-table-column show-overflow-tooltip prop="division" width="200" label="区域划分" align="center"></el-table-column> -->
      <el-table-column prop="associatedEntryPoint" label="关联考点（个）" width="140" align="center"></el-table-column>
      <el-table-column prop="testSiteSupervisorName" label="市级管理员" show-overflow-tooltip width="200" align="center"></el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="140" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip label="合作单位管理员" width="200" align="center">
        <template slot-scope="{ row }">
          <span v-for="(item, index) in row.secondSiteSupervisor"> <span v-if="index !== 0">,</span> {{ `${item.name}(${item.userName})` }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="address" label="地址" align="center"></el-table-column>


      <el-table-column label="状态" fixed="right" width="100px" align="center"  v-if="tableList&&tableList.length>0&&(tableList[0].zybm==0||tableList[0].zybm==1)">
        <template slot-scope="scope">
          <div class="tableSwitch">
            <el-switch v-model="scope.row.status" :disabled="!$roleFilter('city::enable')" class="switch" @change="releaseSwitch(scope.row)" active-color="#409eff" active-text="启用" :active-value="1" inactive-color="#c0c4cc" inactive-text="禁用" :inactive-value="0" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否开放自由报名" fixed="right" width="100px" align="center"   v-if="tableList&&tableList.length>0&&(tableList[0].zybm==0||tableList[0].zybm==1)">
        <template slot-scope="scope">
          <div class="tableSwitch">
            <el-switch v-model="scope.row.zybm"  class="switch" @change="releaseSwitch1(scope.row)" active-color="#409eff" active-text="是" :active-value="1" inactive-color="#c0c4cc" inactive-text="否" :inactive-value="0" />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140" fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="tableContentUpdateBut" @click="operatInfo(2, scope.row)" v-if="$roleFilter('city::update')">修改</el-button>
          <span style="margin: 0px 5px;"  v-if="$roleFilter('city::update') && $roleFilter('city::delete')">|</span>
          <el-button type="text" class="tableContentRemoveBut" @click="operatInfo(0, scope.row)" v-if="$roleFilter('city::delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content" @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '添加' : '修改'" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="400px">
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p><span style="color:red;">*</span>市代名称:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.examSiteName" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p><span style="color:red;">*</span>所属省份:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.provinceId" filterable style="width:100%" placeholder="请选择">
              <el-option v-for="(item, index) in getExamineeList" :key="index" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p>财务分成比例:</p>
          </el-col>
          <el-col :offset="1">
            <el-input-number v-model="visibleObj.percent" controls-position="right" :controls="false" :precision="2" :min="0" :max="100"></el-input-number>
            <span class="number-input-span">%</span>
          </el-col>
        </el-row> -->
        <!-- <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p>区域划分:</p>
          </el-col>
          <el-col :offset="1">
            <el-input style="width:85%" v-model="divisionName" placeholder="请输入后点击加号添加"></el-input>
            <i class="el-icon-circle-plus" @click="addTag"></i>
            <div>
              <el-tag class="dailogTag" v-for="(item, index) in divisionList" size="small" closable @close="removeTag(item)" :key="index">{{ item }}</el-tag>
            </div>
          </el-col>
        </el-row> -->
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p><span style="color:red;">*</span>市级管理员:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.testSiteSupervisor" style="width:100%" filterable placeholder="请选择">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.userName + '(' + item.name + ')'" :value="item.userId"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p>合作单位管理员:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.secondSiteSupervisor" multiple style="width:100%" filterable placeholder="请选择">
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.userName + '(' + item.name + ')'" :value="item.userId"> </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="9">
            <p><span style="color:red;">*</span>地 址:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.address" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown'

export default {
  components: {
    FileOperatDropdown
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      userList: [],
      adminList: [],
      examineeList: [],
      divisionList: [],
      divisionName: '',
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        address: '', //地址
        // division: '', //区域划分
        examSiteName: '', //市代名称
        provinceId: '', //所属省份ID
        testSiteSupervisor: '', //负责人
        percent: 80, //财务分成比例
        secondSiteSupervisor: []
      },
      proList: [], //省份下拉框
      query: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        provinceId: '' //省份
      }
    }
  },
  mounted() {
    this.getAllUser()
    this.tableLoad()
    //获取全部省份
    this.getAllprovince()
  },
  computed: {
    getExamineeList() {
      return this.examineeList.map(item => {
        item.value *= 1
        return item
      })
    }
  },
  methods: {
    //修改市代状态
    releaseSwitch(row) {
      const updateStatus = row.status
      row.status = (row.status) === 0 ? 1 : 0;
      this.$dailog({
        title: updateStatus === 1 ? "启用" : "禁用",
        context: updateStatus === 1 ? "是否确认启用？" : "是否确认禁用？",
        htmlContext: updateStatus === 1 ? "启用后请手动启用相关考点。" : "禁用后，考生将不可选到此市代下考点。",
        callbackFun: () => {
          this.$axios.put(`/examination/site/status/${row.id}/${updateStatus}`).then((res) => {
            this.tableLoad();
            this.$message({ type: "success", message: "操作成功!", duration: 1000 });
          });
        },
      });
    },
    releaseSwitch1(row) {
      console.log(row);
      this.$axios
        .put(`/examination/site/${row.id}/${row.zybm}`)
        .then((res) => {
          this.$message({
                type: "success",
                message: "操作成功!",
               
              });
              this.tableLoad();
        });
      // this.times = []
    },
    //获取全部省份
    getAllprovince() {
      this.$axios.get('/province/select').then(res => {
        this.proList = res.data.data
      })
    },
    tableLoad() {
      this.$axios.post('/examination/site/list', this.query).then(res => {
        let { list, total } = res.data.data
        this.tableList = list
        this.query.total = total
        this.tableIsLoad = false
      })
    },
    getAllUser() {
      this.$axios.get('/user/examination/site/select').then(res => {
        this.userList = res.data.data
      })
      this.$axios.get('/user/examination/secondSite/select').then(res => {
        this.adminList = res.data.data
      })
      this.$axios.get('/province/select').then(res => {
        this.examineeList = res.data.data
      })
    },
    operatInfo(type, row) {
      this.divisionName = '' //区域划分的字段
      this.visibleType = type
      this.visibleObj = {
        address: '', //地址
        // division: '', //区域划分
        examSiteName: '', //市代名称
        provinceId: '', //所属省份ID
        testSiteSupervisor: '', //负责人
        percent: 80,
        secondSiteSupervisor: []
      }
      this.divisionList = []
      if (type === 0) {
        //删除
        let context = row.gridDelete ? '是否删除数据？' : '该市代已关联' + row.associatedEntryPoint + '个考点，删除后相关考点要重新关联市代，是否继续删除？'
        this.$dailog({
          title: '删除',
          context,
          callbackFun: () => {
            this.$axios.delete('/examination/site/' + row.id).then(res => {
              this.$message({
                type: 'success',
                message: '操作成功!',
                duration: 1000
              })
              this.tableLoad()
            })
          }
        })
      } else if (type === 1) {
        //添加
        this.visible = true
      } else if (type == 2) {
        //修改
        this.visible = true
        this.visibleObj = JSON.parse(JSON.stringify(row))
        // this.divisionList = this.visibleObj.division == '' ? [] : this.visibleObj.division.split(',')
        this.visibleObj.secondSiteSupervisor = this.visibleObj.secondSiteSupervisor.map(item => item.userId)
      }
    },
    submit() {
      let { address, examSiteName, provinceId, testSiteSupervisor, id } = this.visibleObj
      if (address === '' || examSiteName === '' || provinceId === '' || testSiteSupervisor === '') {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000
        })
        return
      }
      let subType = this.visibleType === 1 ? 'post' : 'put'
      let url = this.visibleType === 1 ? '/examination/site' : '/examination/site/' + id
      // this.visibleObj.division = this.divisionList.length == 0 ? '' : this.divisionList.join(',')
      this.$axios({
        method: subType,
        url: url,
        data: this.visibleObj
      }).then(res => {
        this.$message({
          type: 'success',
          message: '保存成功!',
          duration: 1000
        })
        this.visible = false
        this.tableLoad()
      })
    },
    removeTag(val) {
      this.divisionList = this.divisionList.filter(item => {
        return item !== val
      })
    },
    addTag() {
      if (this.divisionName.trim() == '') {
        this.$message({
          type: 'warning',
          message: '请填写添加数据！',
          duration: 1000
        })
        return
      }
      if (this.divisionList.find(item => item === this.divisionName)) {
        this.$message({
          type: 'warning',
          message: '无法重复添加区域！',
          duration: 1000
        })
        return
      }
      if (this.divisionName.length > 50) {
        this.$message({
          type: 'warning',
          message: '添加区域长度不能大于50！',
          duration: 1000
        })
        return
      }
      this.divisionList.unshift(this.divisionName)
      this.divisionName = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.tableHearInputBox {
  .el-select {
    width: 140px;
    margin-left: 10px !important;
  }
}
.number-input-span {
  position: relative;
  left: -20px;
}
.examlocation {
  .el-icon-circle-plus {
    color: #409eff;
    font-size: 18px;
    margin-left: 10px;
    cursor: pointer;
  }

  .dailogTag {
    margin: 5px 5px 0px 0px;
  }
}
</style>
